export default __webpack_public_path__ + "static/nasdaq-bde16574de862c7cd31ff62d15df463b.png";